/**
 * @typedef Lpu
 * @property { number | null } id -
 * @property { string } name -
 * @property { string } address -
 * @property { boolean } isServiceDirect -
 */

/** @returns { Array<Lpu> } - */
const getLpuList = () => []

export {
  getLpuList,
}
